import { render, staticRenderFns } from "./VisitanteAdmMovi.vue?vue&type=template&id=3a02651a&"
import script from "./VisitanteAdmMovi.vue?vue&type=script&lang=js&"
export * from "./VisitanteAdmMovi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports